import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Miscellaneous = [
  { name: 'About Us', routerPath: '/about' },
  { name: 'Services', routerPath: '/services' },
  { name: 'Services Details', routerPath: '/services-details' },
  { name: 'Team', routerPath: '/team' },
  { name: 'Team Details', routerPath: '/team-details' },
  { name: 'Price', routerPath: '/price' },
  { name: 'FAQ', routerPath: '/faq' },
  { name: 'Error-404', routerPath: '/error' },
  { name: 'Login', routerPath: '/login' },
  { name: 'Signup', routerPath: '/signup' },
  { name: 'Coming Soon', routerPath: '/coming-soon' },
];

const DropdownSection = ({ title, items, onClick }) => {
  const [open, setOpen] = useState(false);
  return (
    <li className={`has-dropdown ${open ? 'open' : ''}`}>
      <button type="button" onClick={() => setOpen(!open)} className="dropdown-toggle">
        {title}
      </button>
      {open && (
        <ul className="sub-menu">
          {items.map((val, i) => (
            <li key={i} onClick={onClick}>
              <Link to={val.routerPath}>{val.name}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

const MobileMenu = ({ onClick, active }) => {
  return (
    <div className={`mobile-menu-wrapper ${active} d-lg-none`}>
      <div className="mobile-logo mb-5">
        <Link to="/"><img src="assets/img/logo/header-logo-1.png" alt="logo" /></Link>
      </div>
      <div className="close-menu" onClick={onClick}>
        <i className="bi bi-x-lg"></i>
      </div>
      <div className="side-mobile-menu">
        <ul className="menu">
          <li onClick={onClick}>
            <Link to="/">Home</Link>
          </li>
          <DropdownSection title="Pages" items={Miscellaneous} onClick={onClick} />
          <li onClick={onClick}>
            <Link to="/project-details">Project</Link>
          </li>
          <li onClick={onClick}>
            <Link to="/blog">Blog</Link>
          </li>
          <li onClick={onClick}>
            <Link to="/contact">Contact Us</Link>
          </li>
        </ul>
      </div>
      <div className="login-btn text-center mt-4">
        <Link className="theme_btn w-100" to="/login">Login</Link>
        <p className="text-white">
          Don't have an account? <Link to="/signup" className="border-bottom">Signup</Link> today
        </p>
      </div>
    </div>
  );
};

export default MobileMenu;
